/**
 * Counts the total number of true values in an object.
 * @param {any} obj - The object to count true values.
 * @returns {number} The total count of true values in the object.
 */
export const countTrueValues = (obj: any): number => {
    return Object.values(obj).filter((value) => value).length
}